import { verifyCredential } from "./states";

export const services = {
  verifyCredential,
};
